// https://digital.vfc.com/wiki/spaces/AN/pages/416779947/Order+Details

import type { OrderDetails, OrderDetailsItem } from '#commerce/utils/transformOrderDetails'

export default {
  onClickProductExchange: (order: OrderDetails, products: OrderDetailsItem[]) => ({
    event: 'loadEventData',
    eventCategory: 'Order Details',
    eventAction: 'Product Exchange',
    eventLabel: `${order.orderNumber} - ${products.map(({ masterId }) => masterId).join('|')}`, // e.g. "P0449630 - VN000D3HBKA|VN0A7Q5M6BT"
    nonInteractive: false,
    customMetrics: {},
    customVariables: {}
  }),
}
